import {useLang} from "../context/LanguageContext";
import DateUtils from "../utils/dateUtils";
import Dots3 from "../images/3dots.svg";
import {useState} from "react";
import Api from "../utils/Api";


const MySubscription = ({subscription, setShowMessage}) => {
    const { t } = useLang();
    const [showDetails, setShowDetails] = useState(false);

    const unsubscribe = async () => {
        const confirmChoice = window.confirm(t('subs.confirmTitle'))
        if(confirmChoice){
            try {
                await Api.cancelSubscription(subscription.id)
            } catch (error) {
                console.error(error);
                alert(t('subs.cancelError'));
                return;
            }
            setShowDetails(false);
            setShowMessage(true);
        }
    }

    return (
        <div>
            <h3>
                {t('subs.type')}: {t('subs.name')} {subscription.title}
            </h3>
            <h3>
                {t('subs.status')}: {t('subs.status_' + subscription.status)}
            </h3>
            <h3>
                {t('subs.dateStart')}: {DateUtils.getDay(subscription.start_date)}
            </h3>
            <h3>
                {t('subs.dateEnd')}: {DateUtils.getDay(subscription.current_period_end)}
            </h3>
            {
                subscription.cancel_at_period_end &&
                <h3 className="font-bold text-orange-600">
                    {t('subs.activeUntilCanceled')} {DateUtils.getDay(subscription.current_period_end)}
                </h3>
            }

            {
                !subscription.cancel_at_period_end &&
                <button
                    onClick={() => setShowDetails(true)}
                    className="flex items-center space-x-2"
                >
                    {/*{t('btn.details')}*/}
                    <img src={Dots3} alt="alt" className="h-[34px]"/>
                </button>
            }

            {
                showDetails === true &&
                <div className="relative bg-gray-200 p-5">
                    <h1 className="flex justify-between">
                        {t('subs.detailsTitle')}
                        <button onClick={() => setShowDetails(false)}
                                className="px-4 py-2 bg-gray-300 rounded flex items-center space-x-2">
                            {t('btn.close')}
                        </button>
                    </h1>
                    <p>
                        {t('subs.detailsContent1')} {DateUtils.getDay(subscription.start_date)}
                        {t('subs.detailsContent2')} {DateUtils.getDay(subscription.current_period_end)}
                        {t('subs.detailsContent3')}&nbsp;
                        <span className="font-bold cursor-pointer" onClick={() => unsubscribe(true)}>
                                                {t('subs.detailsHere')}
                                            </span>
                        <br />
                        <br />
                        {t('subs.detailsContent4')}
                    </p>
                </div>
            }


        </div>
    )
}

export default MySubscription;